// extracted by mini-css-extract-plugin
export default {"footer":"PriceComparisonFooter_footer__Dc-be","cancelButton":"PriceComparisonFooter_cancelButton__ZB4AR","priceBreakdown":"PriceComparisonFooter_priceBreakdown__T1liM"};